'use client';

import { createContext } from 'react';

/**
 * Which block type is currently delegating to its platform implementation.
 *
 * <p>Every override in this theme works the same way: render a wrapper, then render the
 * SAME block type again with the theme cleared so the resolver falls through to the
 * platform's canonical component. If the cleared theme ever resolves back to the
 * override — because the clear did not take, or because a second resolver is in play —
 * that is an infinite render, and an infinite render in the SHELL takes the whole
 * document down rather than one block.
 *
 * <p>So each override reads this on the way in and refuses to re-enter for its own type.
 *
 * <p><strong>It lives in its own module so there is exactly one context object.</strong>
 * Declared per file, `TradeSkin` and {@link TradeShell} would each hold a different
 * `createContext` result; a provider from one would be invisible to the reader in the
 * other, and the guard would silently stop guarding at exactly the boundary where the
 * shell wraps the blocks.
 */
export const DelegatingType = createContext<string | null>(null);
